import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core";
import { recordTypes } from "../../../../API/config";
import EntityAddress from "../../../EntityAddresses";
import { AttributeGroup } from "../../../../Component";
import styles from "./styles";
import { useTranslation } from "react-i18next";

const BasicInfo = (props) => {
  const {
    classes,
    entity,
    hasRecordPermission,
    onContactUpdate,
    handleOnChange,
    handleOnUnitChange,
    basicAttributes = [],
    listOptions,
  } = props;
  const { confidential } = entity || {};
  const { t } = useTranslation();

  const [canViewAddresses, setCanViewAddresses] = useState();
  const [maskSensitive, setMaskSensitive] = useState(false);

  useEffect(() => {
    const setPermissions = async () => {
      const { permissions = {} } = entity;
      const canViewAddresses = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewAddresses.name,
      );
      setCanViewAddresses(canViewAddresses);
      const canViewSensitiveFields = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewSensitiveFields.name,
      );
      if (confidential && !canViewSensitiveFields) {
        setMaskSensitive(true);
      }
    };
    setPermissions();
  }, [entity]);

  const handleChange = (attrId, newValue) => {
    handleOnChange(attrId, newValue);
  };

  const handleUnitChange = (attrId, newUnitValue) => {
    handleOnUnitChange(attrId, newUnitValue);
  };

  const renderBasicAttributes = () => {
    const subSectionElements = [];

    for (let sc in basicAttributes) {
      subSectionElements.push(
        <div key={sc} className={classes.inputContainerStyle}>
          <AttributeGroup
            attributes={basicAttributes[sc]}
            maskSensitive={maskSensitive}
            onChange={handleChange}
            onUnitChange={handleUnitChange}
            listOptions={listOptions}
          />
        </div>,
      );
    }

    return subSectionElements;
  };

  return (
    <div className={classes.pageContent}>
      {renderBasicAttributes()}
      {canViewAddresses && (
        <EntityAddress
          entity={entity}
          onContactUpdate={onContactUpdate}
          hasRecordPermission={hasRecordPermission}
        />
      )}
    </div>
  );
};
export default withStyles(styles, { withTheme: true })(BasicInfo);
